// components/Authors/publishers.jsx
import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import Header2 from "../../header2/index-two";
import InstructorSidebar from "../sidebar";
import { AppContext } from "../../../services/AuthContext";
import { ListByAuthorid } from "../../../services/userpanelservice";
import { getpublisherstemplatesandattributedata } from "../../../services/publisherstemplatesandattributeService";

const AuthorsPublisher = () => {
  const { auth } = useContext(AppContext);
  const { id } = useParams();
  const [publishers, setPublishers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Yardımcı: attribute listesinden istenen alanı (örn. "Ülke", "İl") çek
  const pickAttr = (items, wanted) => {
    if (!Array.isArray(items)) return "";
    const row = items.find(
      (x) =>
        x?.publisherdata?.attributedata?.templatetypeandattribute?.attribute?.attrname?.toLowerCase() ===
        wanted.toLowerCase()
    );
    // datajson -> [{lang, value: [ "Türkiye" ]}]
    const valArr = row?.datajson?.[0]?.value || [];
    if (!Array.isArray(valArr)) return "";
    const flat = valArr.filter(Boolean).map((s) => String(s).trim()).filter(Boolean);
    return flat.join(", ");
  };

  const parsePublisherData = (items) => {
    if (!Array.isArray(items) || items.length === 0) return [];
    return items.map((item) => {
      const top = item || {};
      const old = item?.elasticjson || {};
      return {
        id: top.id ?? old.mysqlId ?? null,
        title: top.title ?? old.title ?? "-",
      };
    }).filter(p => p.id); // id’si olmayanları ele
  };

  // 1) Yayıncı listesi (yazara göre)
  const fetchPublishers = async () => {
    try {
      const data = await ListByAuthorid(id, 0, 10, auth.token);
      if (data?.status === "OK") {
        const base = parsePublisherData(data.data);
        // 2) Her yayıncı için ülke/il çek
        const enriched = await Promise.all(
          base.map(async (p) => {
            try {
              const attrs = await getpublisherstemplatesandattributedata(p.id, 1, auth.token);
              const rows = attrs?.data || [];
              return {
                ...p,
                country: pickAttr(rows, "Ülke") || "",
                city: pickAttr(rows, "İl") || "", // “İlçe” istersen ayrıca eklenebilir
              };
            } catch {
              return { ...p, country: "", city: "" };
            }
          })
        );
        setPublishers(enriched);
      } else {
        setPublishers([]);
      }
    } catch (e) {
      console.error("Error fetching publishers:", e);
      setPublishers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchPublishers(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="main-wrapper mt-5">
      <Header2 />
      <div className="page-content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <InstructorSidebar />
            {/* /Sidebar */}
            <div className="col-xl-9 col-lg-9">
              <div className="settings-widget card-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Yayıncı Bilgileri</h3>
                  </div>
                  <div className="instructor-course-table">
                    <div className="table-responsive custom-table">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th>Yayıncı Başlık</th>
                            <th>Ülke</th>
                            <th>Şehir (İl)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="3" className="text-center">Yükleniyor...</td>
                            </tr>
                          ) : publishers.length > 0 ? (
                            publishers.map((publisher) => (
                              <tr key={publisher.id}>
                                <td>
                                  <Link className="course-table-img" to={`/publisher-detail/${publisher.id}`}>
                                    {publisher.title}
                                  </Link>
                                </td>
                                <td>{publisher.country || "-"}</td>
                                <td>{publisher.city || "-"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                Yayıncı bilgisi bulunamadı.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Publishers */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorsPublisher;
